import { useMemo, useContext } from 'react';
// import ReactEcharts from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { isEmptyObject } from '@/utils/comUtil';
import { sinTimeDimensionSinIndexMulValue } from '@/utils/reportResponseUtil';

import {
  // LineChart,
  // BarChart,
  PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  // GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  // CustomChart,
} from 'echarts/charts';
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  // GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  // TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from 'echarts/components';
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';

// Register the required components
echarts.use([TitleComponent, CanvasRenderer, PieChart]);

// 图表容器样式提到模块级，保证引用稳定，
// 避免 ReactEChartsCore 因为 props 引用变化而重复 setOption
const CHART_STYLE = { width: '100%', height: '100%' };

const AgeDistribution = (props) => {
  const { loading, data, boxId } = props;
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const { charts } = themeContext[brandContext];

  // console.log(charts,'charts');

  const { chartsFontSize, fontFamily } = themeContext.comm;
  // 图表数据派生值做缓存，避免每次渲染重复计算
  const result = useMemo(
    () =>
      sinTimeDimensionSinIndexMulValue(data?.data)?.map((e) => ({
        value: e.VALUE,
        name: e.LABEL,
      })) || [],
    [data],
  );
  // 完善资料人数
  const profileCompletedCount = useMemo(
    () => result.filter((e) => e.name === '完善信息')[0]?.value ?? 0,
    [result],
  );
  // 填写年龄人数
  const ageFilledCount = useMemo(
    () => result.filter((e) => e.name === '填写年龄')[0]?.value ?? 0,
    [result],
  );
  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const chartOption = useMemo(() => {
    if (isEmptyObject(data) || data?.length === 0) {
      return {};
    }

    let seriesData = result.filter(
      (e) => e.name !== '完善信息' && e.name !== '填写年龄',
    );

    // const legendData = data.xDataList;
    let option = {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      color: charts.lineColorList,
      tooltip: {
        trigger: 'item',
        // formatter: `{b} : {c} ({d}%)；已完善资料${profileCompletedCount}人，已填年龄的${ageFilledCount}人`,
        formatter: '{b} : {c} ({d}%)；',
        textStyle: {
          fontSize: chartsFontSize.s03,
          fontWeight: 'bold',
        },
        confine: true,
      },
      series: [
        {
          itemStyle: {
            borderRadius: 4,
          },
          radius: ['15%', '50%'],
          roseType: 'area',
          name: '',
          type: 'pie',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          // roseType: 'radius',
          minAngle: 18,
          emphasis: {
            label: {
              show: true,
            },
          },
          labelLine: {
            normal: {
              length: 15,
            },
          },
          label: {
            rich: {
              a: {
                color: '#999',
                lineHeight: 16,
                align: 'center',
              },
              hr: {
                borderColor: '#aaa',
                width: '100%',
                borderWidth: 0.5,
                height: 0,
              },
              b: {
                fontSize: 12,
                lineHeight: 16,
              },
              per: {
                color: '#eee',
                backgroundColor: '#334455',
                padding: [10, 20],
                borderRadius: 2,
              },
            },
          },
          data: seriesData,
        },
      ],
    };

    return option;
  }, [data, result, chartsFontSize.s03, fontFamily, charts.lineColorList]);

  return (
    <>
      {/* <Head boxId={'ec.dashboard.n03.lbl01'}> </Head> */}
      <Head
        boxId={boxId}
        extra={{ profileCompletedCount, ageFilledCount }}
      ></Head>
      <Body bizData={data?.data} loading={loading}>
        {/* <ReactEcharts
          style={{ width: '100%', height: '100%' }}
          option={echartsOptions || {}}
          notMerge={true}
          lazyUpdate={true}
          //   onEvents={onEvents}
        /> */}
        <ReactEChartsCore
          echarts={echarts}
          lazyUpdate={true}
          option={chartOption}
          notMerge={true}
          style={CHART_STYLE}
        />
      </Body>
    </>
  );
};
export default AgeDistribution;
